import React, {useRef, useState } from 'react'
import './TicTacToe.css'
import circle_icon from '../Assets/circle.png'
import cross_icon from '../Assets/cross.png'

let data = ["", "", "", "", "", "", "", "", ""];

const TicTacToe = () => {

    let [count, setCount] = useState(0);
    let [lock, setLock] = useState(false);
    let [language, setLanguage] = useState('en');
    let titleRef = useRef(null);

    const translations = {
        en: {
            title: 'TicTacToe Game by',
            playerTurn: 'Player Turn:',
            congratulations: 'Congratulations: Player',
            won: 'Won!',
            draw: 'It\'s a Draw!',
            reset: 'Reset'
        },
        pt: {
            title: 'Jogo da Velha por',
            playerTurn: 'Vez do Jogador:',
            congratulations: 'Parabéns: Jogador',
            won: 'Venceu!',
            draw: 'Empate! Jogo da Velha',
            reset: 'Reiniciar'
        }
    };

    const t = translations[language];
    let box1 = useRef(null);
    let box2 = useRef(null);
    let box3 = useRef(null);
    let box4 = useRef(null);
    let box5 = useRef(null);
    let box6 = useRef(null);
    let box7 = useRef(null);
    let box8 = useRef(null);
    let box9 = useRef(null);

    let box_array = [box1, box2, box3, box4, box5, box6, box7, box8, box9];

    const toggle = (e,num) => {
        if(lock){
            return 0;
        }
        if(count%2 === 0){
            e.target.innerHTML= `<img src='${cross_icon}'>`;
            data[num] = "X";
            setCount(++count);
        } else {
            e.target.innerHTML= `<img src='${circle_icon}'>`;
            data[num] = "O";
            setCount(++count);
        }
        checkWinner();
    }

    const checkWinner = () => {
        if (data[0] === data[1] && data[1] === data[2] && data[2] !== "") {
            won(data[2]);
        }
        else if (data[3] === data[4] && data[4] === data[5] && data[5] !== "") {
            won(data[5]);
        }
        else if (data[6] === data[7] && data[7] === data[8] && data[8] !== "") {
            won(data[8]);
        }
        else if (data[0] === data[3] && data[3] === data[6] && data[6] !== "") {
            won(data[6]);
        }
        else if (data[1] === data[4] && data[4] === data[7] && data[7] !== "") {
            won(data[7]);
        }
        else if (data[2] === data[5] && data[5] === data[8] && data[8] !== "") {
            won(data[8]);
        }
        else if (data[0] === data[4] && data[4] === data[8] && data[8] !== "") {
            won(data[8]);
        }
        else if (data[2] === data[4] && data[4] === data[6] && data[6] !== "") {
            won(data[6]);
        }
        else if (count === 9) {
            draw();
        }
    }

    const won = (winner) => {
        setLock(true);
        if(winner === "X"){
            titleRef.current.innerHTML = `${t.congratulations} <img src='${cross_icon}'> ${t.won}`;
        } else {
            titleRef.current.innerHTML = `${t.congratulations} <img src='${circle_icon}'> ${t.won}`;
        }
    }

    const draw = () => {
        setLock(true);
        titleRef.current.innerHTML = `${t.draw}`;
    }

    const toggleLanguage = () => {
        const newLang = language === 'en' ? 'pt' : 'en';
        setLanguage(newLang);
        if (!lock) {
            titleRef.current.innerHTML = `${translations[newLang].title} <span>@lucsantosdev</span>`;
        }
    }

    const resetGame = () => {
        setLock(false);
        setCount(0);
        data = ["", "", "", "", "", "", "", "", ""];
        titleRef.current.innerHTML = `${t.title} <span>@lucsantosdev</span>`;
        box_array.forEach((e) => {
            e.current.innerHTML = "";
        });
    }

  return (
    <div className='container'>
      <button className='language-toggle' onClick={toggleLanguage}>
        {language === 'en' ? '🇧🇷 PT' : '🇺🇸 EN'}
      </button>
      <h1 className='title' ref={titleRef}>{t.title} <span>@lucsantosdev</span></h1>
      <div className='player-turn'>
        {!lock && (
          <p>{t.playerTurn} {count % 2 === 0 ? <img src={cross_icon} alt="X" className='turn-icon' /> : <img src={circle_icon} alt="O" className='turn-icon' />}</p>
        )}
      </div>
      <div className="board">
        <div className="row1">
            <div className="boxes" ref={box1} onClick={(e)=>{toggle(e,0)}}></div>
            <div className="boxes" ref={box2} onClick={(e)=>{toggle(e,1)}}></div>
            <div className="boxes" ref={box3} onClick={(e)=>{toggle(e,2)}}></div>
        </div>
        <div className="row2">
            <div className="boxes" ref={box4} onClick={(e)=>{toggle(e,3)}}></div>
            <div className="boxes" ref={box5} onClick={(e)=>{toggle(e,4)}}></div>
            <div className="boxes" ref={box6} onClick={(e)=>{toggle(e,5)}}></div>
        </div>
        <div className="row3">
            <div className="boxes" ref={box7} onClick={(e)=>{toggle(e,6)}}></div>
            <div className="boxes" ref={box8} onClick={(e)=>{toggle(e,7)}}></div>
            <div className="boxes" ref={box9} onClick={(e)=>{toggle(e,8)}}></div>
        </div>
      </div>
      <button className='reset' onClick={() => {resetGame()}}>{t.reset}</button>
    </div>
  );
}

export default TicTacToe;
